enum QuantityTypes {
    regular = 'REGULAR',
    timed = 'TIMED',
}

export default QuantityTypes;
